import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PortalVerification from "@/pages/PortalVerification";
import Portal from "@/pages/Portal";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortalVerification />} />
          <Route path="/portal" element={<Portal />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;